export const gitCommit = '7739d521'
